import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowsPage', {
    title: 'Approval Workflows | {companyName}',
    breadcrumbsSectionName: 'Approval workflows',
    tutorialContent: 'Click CREATE to set up your first workflow',
});
